module.exports = __webpack_public_path__ + "static/media/calendar.0512c989.svg";